import React from "react";
import Container from "@material-ui/core/Container";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Contact from "./Contact";
import Grid from "@material-ui/core/Grid";

function ContactSection(props) {
  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container maxWidth="md">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />
        <Contact
          showNameField={props.showNameField}
          buttonText={props.buttonText}
          buttonColor={props.buttonColor}
        />
            <Container maxWidth="sm" style={{marginTop: 20, color: 'lightgray'}}>
            For immediate assistance, contact showNAV Customer Service at <a href='tel: +1 (310) 853 - 0839' style={{color: '#0059a6', textDecoration: 'none'}}>+1 (310) 853 - 0839</a>
          </Container>
      </Container>
      
    </Section>
  );
}

export default ContactSection;
